import { EditOutlined, EllipsisOutlined, CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { useNavigate } from 'react-router';

import { useDeleteMainPageMutation, usePublishMainPageMutation } from '@/api/endpoints/mainPages';
import { DropdownLabel } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import styles from './UnpublishedDropdown.module.scss';

type TProps = {
  id: number;
};

export const UnpublishedDropdown = ({ id }: TProps) => {
  const [publishPageVersion, { isLoading: isPageVersionPublishing }] = usePublishMainPageMutation();
  const [deletePageVersion, { isLoading: isPageVersionDeleting }] = useDeleteMainPageMutation();

  const navigate = useNavigate();

  const sendApiRequest = useApiRequest();

  const publishPageVersionHandler = () =>
    sendApiRequest({
      successMessage: 'Версия успешно опубликована',
      apiRequestCallback: () => publishPageVersion({ id }),
    });

  const deletePageVersionHandler = () =>
    sendApiRequest({
      successMessage: 'Версия успешно удалена',
      apiRequestCallback: () => deletePageVersion({ id }),
    });

  const dropdownItems: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: (
        <DropdownLabel
          text="Редактирование"
          onClick={() => navigate(`${id}`)}
        />
      ),
    },
    {
      key: 'publish',
      icon: <CheckCircleOutlined />,
      disabled: isPageVersionPublishing || isPageVersionDeleting,
      label: (
        <DropdownLabel
          text="Опубликовать"
          onClick={publishPageVersionHandler}
        />
      ),
    },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      disabled: isPageVersionPublishing || isPageVersionDeleting,
      label: (
        <DropdownLabel
          text="Удалить"
          onClick={deletePageVersionHandler}
        />
      ),
    },
  ];

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items: dropdownItems,
        onClick: (dropdownItem) => {
          dropdownItem.domEvent.stopPropagation();
        },
      }}
      classNames={{
        root: styles['dropdown-overlay'],
      }}
    >
      <Button
        className={styles['dropdown-button']}
        onClick={(e) => e.stopPropagation()}
      >
        <EllipsisOutlined />
      </Button>
    </Dropdown>
  );
};
